import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { t } from "@bookingcom/lingojs-core";
import { useI18n } from "@bookingcom/lingojs-react";
import { Button, useTheme } from "@bookingcom/bui-react";
import NotAvailableIllustration from "../../../../assets/illustrations/not-available.svg";
import { useScreenNavigation } from "../../../../app/navigation.js";
import Frame from "../../Frame/index.js";
import FloatingPanel from "../../../atoms/FloatingPanel/index.js";
import { KAYAK_ADS } from "../../../../constants.js";
import useClientMetrics from "../../../../hooks/useClientMetrics.js";
import { goal } from "@flights/et-universal";
export const NoResultsFound = (props) => {
    const theme = useTheme();
    const i18n = useI18n();
    const location = useLocation();
    const { trackClientMetric } = useClientMetrics();
    const queryParams = new URLSearchParams(location.search);
    const caSource = queryParams.get("ca_source") || "";
    const { showActions } = props;
    const navigateHome = useScreenNavigation("home");
    useEffect(() => {
        goal("flights_empty_search_results_page_view");
    }, []);
    useEffect(() => {
        if (caSource === KAYAK_ADS) {
            trackClientMetric("kayak_ads_empty_search_results_page_view");
        }
    }, [caSource, trackClientMetric]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement(Frame, { attributes: {
                    style: {
                        ...theme.fonts.small.font_emphasized_2,
                        color: theme.colors.color_foreground_alt,
                        textAlign: "center"
                    }
                }, m: 4 }, i18n.trans(t("flights_search_no_results"))),
            React.createElement("div", { style: { margin: `0 -${theme.units.spacing_4x}` } },
                React.createElement(NotAvailableIllustration, null))),
        showActions && (React.createElement(FloatingPanel, { align: "bottom", fixed: true },
            React.createElement(Frame, { m: 4 },
                React.createElement(Button, { onClick: navigateHome, variant: "secondary" }, i18n.trans(t("flights_search_change_search_button"))))))));
};
